<template>
  <div>
    <div class="tier-plan-box skeleton-plan">
      <h2 class="tiername skeleton skeleton-line w-50" />
      <div class="tier-plan-box__top">
        <div class="tier-plan-box__top--description">
          <p class="skeleton skeleton-line w-100" />
          <p class="skeleton skeleton-line w-100" />
          <p class="skeleton skeleton-line w-100" />
          <p class="skeleton skeleton-line w-50" />
          <ul class="tier-plan-box__bottom--features">
            <li class="skeleton skeleton-line w-70" />
            <li class="skeleton skeleton-line w-100" />
            <li class="skeleton skeleton-line w-85" />
            <li class="skeleton skeleton-line w-70" />
          </ul>
          <div v-if="!activePlan" style="padding-top: 30px;">
            <div class="skeleton skeleton-line skeleton-price w-30"></div>
            <div class="skeleton skeleton-line skeleton-breakdown w-30"></div>
            <div class="skeleton skeleton-line skeleton-button w-100"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SkeletonPlanBox',
  components: {
  },
  props: {
    activePlan: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {}
  },
  computed: {},
}
</script>

<style lang="scss" scoped>
/* Base skeleton look */
.skeleton {
  position: relative;
  overflow: hidden;
  background: #e9ecef; /* base gray */
  border-radius: 6px;
}
.skeleton-line {
  border-radius: 999px;
}
/* Facebook-style shimmer */
.skeleton::after {
  content: '';
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.55) 50%, transparent 100%);
  animation: skeleton-shimmer 1.2s infinite;
}

@keyframes skeleton-shimmer {
  100% {
    transform: translateX(100%);
  }
}

.tier-plan-box.skeleton-plan {
  // width: 360px;
  .tiername {
    height: 30px;
    margin-bottom: 24px;
  }
  .tier-plan-box__top--description {
    gap: 14px;
    p {
      margin: 0;
      padding: 0;
      height: 10px;
    }

  }
  .tier-plan-box__bottom--features {
    margin-top: 10px;
    li {
      height: 10px;
      margin-bottom: 12px;
    }
  }
  .skeleton-price {
    height: 42px;
    margin-bottom: 8px;
  }
  .skeleton-breakdown {
    height: 12px;
    margin-bottom: 24px;
  }
  .skeleton-button {
    height: 42px;
    border-radius: 50em;
  }
}

.w-30 {
  width: 30%;
}
.w-50 {
  width: 50%;
}
.w-70 {
  width: 70%;
}
.w-85 {
  width: 85%;
}
.w-100 {
  width: 100%;
}

/* Accessibility / reduced motion */
@media (prefers-reduced-motion: reduce) {
  .skeleton::after {
    animation: none;
  }
}
</style>

